import React, { useState } from 'react';
import styles from './StackableCards.module.css';
import bulletIcon from '../../../assets/svg/ai-sales-landing/check_icon.svg';

const StackableCard = ({
  title,
  bulletPoints,
  className,
  imageUrl,
  isActive = false,
  integrationIcons = [],
}) => {
  const [isVideoLoading, setIsVideoLoading] = useState(true);

  return (
    <div
      className={`${styles.featureCard} ${styles?.[className]} ${
        isActive ? styles.active : ''
      }`}
    >
      <div className={styles.contentContainer}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>{title}</h2>

          <div className={styles.bulletPoints}>
            {bulletPoints.map((point, index) => (
              <div key={index} className={styles.bulletPoint}>
                <div className={styles.bulletIcon}>
                  <img src={bulletIcon} alt="bullet_point" />
                </div>
                <p className={styles.bulletText}>{point}</p>
              </div>
            ))}
          </div>

          {integrationIcons.length > 0 && (
            <div className={styles.integrationSection}>
              <div className={styles.integrationIcons}>
                {integrationIcons.map((icon, index) => (
                  <div key={index} className={styles.iconWrapper}>
                    <img
                      src={icon}
                      alt={`Integration ${index + 1}`}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className={styles.imageContainer}>
          {imageUrl ? (
            <>
              {isVideoLoading && (
                <div className={styles.loader}>
                  <div className={styles.spinner}></div>
                </div>
              )}
              <video
                src={`https://ik.imagekit.io/hotelzifyprod/${imageUrl}`}
                alt={title}
                className={styles.featureImage}
                autoPlay={true}
                loop={true}
                playsInline={true}
                muted={true}
                onLoadStart={() => setIsVideoLoading(true)}
                onLoadedData={() => setIsVideoLoading(false)}
                style={{ borderRadius: '5%' }}
              />
            </>
          ) : (
            <div className={styles.placeholderImage}>
              <span className={styles.placeholderText}>placeholder</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StackableCard;
